import { styled } from "@mui/material/styles";
import { Box, Card } from "@mui/material";

export const ModuleListContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    flex: 1,
    maxHeight: "400px",
    overflowY: "auto",
    paddingRight: 6,
}));

export const ItemCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    background: theme.palette.background.paper,
}));

export const ItemHeader = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));

export const ItemMeta = styled(Box)(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(0.5, 1),
}));

export const MetaRow = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
}));

export const ColorDot = styled("div")(({ theme }) => ({
    width: 14,
    height: 14,
    borderRadius: 999,
    backgroundColor: theme.palette.grey[400],
    border: `1px solid ${theme.palette.divider}`,
}));